<div class="pagination-container d-flex justify-content-between align-items-center mt-3">
  <div class="d-flex align-items-center gap-2">
    <span>Rows per page:</span>
    <select
      class="form-select form-select-sm"
      style="width: 80px"
      (change)="changeSize($event)"
    >
      @for (size of pageSizeOptions; track size) {
        <option [value]="size" [selected]="size === pageSize">
          {{ size }}
        </option>
      }
    </select>
    <span>
      Total Records:
      <strong>{{ totalRecords }}</strong>
    </span>
  </div>

  <div class="d-flex align-items-center gap-2 paginationPreNextBTN">
    <button
      class="btn btn-outline-secondary btn-sm"
      [disabled]="currentPage === 1"
      (click)="previous()"
    >
      ‹ &nbsp; Previous
    </button>
    <span> Page {{ currentPage }} of {{ totalPages }} </span>
    <button
      class="btn btn-outline-primary btn-sm"
      [disabled]="currentPage === totalPages"
      (click)="next()"
    >
      Next
    </button>
  </div>
</div>
